<template>
  <div class="wrapper">
    <img src="/static/images/nebo-logo-mobile.svg" alt="Nebo Logo" class="logo">
    <div class="title">выше только небо</div>
    <div class="copyrights">НЕБО 2020 Все права защищены</div>
  </div>
</template>



<script>
  export default {
    name: "MobileStartScreen",
    mounted() {
      if (document.querySelector('.custom-header__item_phone')) document.querySelector('.custom-header__item_phone').style.display = 'none';
    },
    beforeDestroy() {
      if (document.querySelector('.custom-header__item_phone')) document.querySelector('.custom-header__item_phone').style.display = 'inline-block';
    }
  }
</script>

<style lang="stylus" scoped>
  @import '../styles/tools'
  .wrapper
    background-color $backgroundBlue
    display flex
    flex-direction column
    justify-content center
    align-items center
    height 100vh
    min-height 100vh
    width 100%
    position relative

  .logo
    height auto
    object-fit contain
    max-width 300px
    margin-bottom 20px

  .title
    font-family GraphikLCG
    font-size 18px
    text-transform uppercase
    color $white

  .copyrights
    font-family GraphikLCG
    font-size 12px
    color $white
    opacity 0.5
    position absolute
    bottom 30px
    right 20px
</style>